const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createBingoRoom = async (winConditions) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ winConditions }),
  })
  if (!response.ok) throw new Error('Não foi possível criar a sala.')
  return response.json()
}

export const joinBingoRoom = async (id, name) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms/${id}/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  })
  if (!response.ok) throw new Error('Não foi possível entrar na sala.')
  return response.json()
}

export const fetchBingoState = async (id) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms/${id}/state`)
  if (!response.ok) throw new Error('Sala não encontrada.')
  return response.json()
}

export const fetchBingoCard = async (id, participantId) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms/${id}/card/${participantId}`)
  if (!response.ok) throw new Error('Cartela não encontrada.')
  return response.json()
}

// Pass `number` when the master is calling out a number pulled from a
// physical drawer instead of using the digital random draw.
export const drawBingoNumber = async (id, masterToken, number) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms/${id}/draw`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify(number === undefined ? {} : { number }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível sortear.')
  return data
}

export const undrawBingoNumber = async (id, masterToken, number) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms/${id}/undraw`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify({ number }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível desmarcar o número.')
  return data
}

export const removeBingoParticipant = async (id, masterToken, participantId) => {
  const response = await fetch(`${API_URL}/api/bingo-rooms/${id}/participants/${participantId}`, {
    method: 'DELETE',
    headers: { 'x-master-token': masterToken },
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível excluir o participante.')
  return data
}

export const bingoStreamUrl = (id) => `${API_URL}/api/bingo-rooms/${id}/stream`

export const bingoJoinUrl = (id) => `${window.location.origin}/ferramentas/bingo-ao-vivo/${id}`
